<template>
  <nuttrema-layout-mobile-ready ref="mobileLayout" theme="participant" :class="[`is-${gender}`]">

    <router-view></router-view>

    <template slot="sidebar">
      <participant-main-menu
        :PersonalProfile="PersonalProfile"
        :InstanceInfo="InstanceInfo"
        @close="closeSidebar">
      </participant-main-menu>
    </template>

  </nuttrema-layout-mobile-ready>
</template>

<script>
import { get } from 'lodash';

import ResponsiveMonitor from 'components/mixins/responsive-monitor';

import NuttremaLayoutContentHeader from 'components/ui/layout/nuttrema-layout-content-header';

import NuttremaLayoutMobileReady from 'components/ui/layout/nuttrema-layout-mobile-ready';

import ParticipantMainMenu from 'src/components/ui/menu/participant/participant-main-menu';

export default {
  name: 'layout-set-participant',
  mixins: [
    ResponsiveMonitor,
  ],
  components: {
    ParticipantMainMenu,
    NuttremaLayoutMobileReady,
    NuttremaLayoutContentHeader,
  },
  props: {
    token: {
      required: false,
      default: null,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    showEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      options: {
        edit: null,
      },
    };
  },
  computed: {
    InstanceInfo() {
      return this.$store.getters.InstanceInfo;
    },
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
    gender() {
      return get(this.PersonalProfile, 'data.gender') || 'male';
    },
  },
  methods: {
    updateEdit(value) {
      this.$emit('update:edit', value);
    },
    toggleSidebar() {
      this.$refs.mobileLayout.toggleSidebar();
    },
    closeSidebar() {
      this.$refs.mobileLayout.closeSidebar();
    },
  },
  created() {
    this.options.edit = this.edit;
    const query = this.token ? { token: this.token } : null;
    if (query) this.$store.dispatch('GetPersonalPublicProfile', query);
    else this.$store.dispatch('GetPersonalProfile');
  },
  beforeDestroy() {
    this.$store.dispatch('ClearPersonalProfile');
  },
  watch: {
    edit(value) {
      this.options.edit = value;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/layout-set/participant/layout-set-participant.vue